import React, { useState } from 'react'
import { Button, Modal, Table } from 'react-bootstrap'

const ViewOptionalTreatments = ({ enrolment, email }) => {
  const [show, setShow] = useState(false)

  const rows = enrolment.optional_tx_assignments_by_group || []
  const totalCount = rows.reduce(
    (n, row) => n + (row.optional_tx_package_list?.length || 0),
    0
  )

  return (
    <>
      <Button
        variant='primary'
        className='btn-sm m-1'
        onClick={() => setShow(true)}
      >
        Optional Treatments ({totalCount})
      </Button>

      <Modal show={show} onHide={() => setShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Assigned Optional Treatment Chapters</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            <strong>Participant:</strong> {email}
          </p>
          {rows.length > 0 ? (
            rows.map((row, ri) => (
              <div key={ri} style={{ marginBottom: '16px' }}>
                <p style={{ marginBottom: '8px', fontWeight: 'bold' }}>
                  Participant group:{' '}
                  {row.participant_group?.name ||
                    row.participant_group?._id ||
                    row.participant_group ||
                    '—'}
                </p>
                {(row.optional_tx_package_list || []).length > 0 ? (
                  <Table bordered hover responsive className='table-sm'>
                    <thead>
                      <tr>
                        <th>Title</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(row.optional_tx_package_list || []).map((pkg) => (
                        <tr key={pkg._id || pkg}>
                          <td>{pkg.title || pkg._id || pkg}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                ) : (
                  <p style={{ fontStyle: 'italic', fontSize: '0.9rem' }}>
                    No optional chapters for this group.
                  </p>
                )}
              </div>
            ))
          ) : (
            <p style={{ fontStyle: 'italic' }}>
              No optional treatment chapters currently assigned
            </p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={() => setShow(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default ViewOptionalTreatments
